import { Station } from './station';
import { User } from './user';

export class OpeningStation {
    public id: number;
    public received_by: string;
    public ericcson_id: string;
    public expired_at: string;
    public person_in: string;
    public company: string;
    public job: string;
    public confirmation_open: string;
    public confirmation_in: string;
    public confirmation_close: string;
    public closed_at: string;
    public closed_by: string;
    public station_status: string;
    public activated: boolean;
    public user_id: number;
    public user: User;
    public station_id?: Station;
    public station?: Station;
    public created_at: string;
    public updated_at: string;
    public delete_at: string;
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/class/opening-station.ts